<template>
    <div>
        <div class="yearBox">
            <div class="month">{{ getNowDate('month') }}</div>
            <div class="year">{{ getNowDate('year') }}</div>
        </div>
        <div class="dayBox">
            <div v-for="(item,index) in timeData" :key="index" class="timeItem" :class="{ 'dayActive':index == activeDayIndex }" @click="handleDayChange(index)">
                <div>{{ formatWeek(item.dayOfWeek) }}</div>
                <div>{{ getNowDate('day',index) }}</div>
                <div class="timeLine"></div>
            </div>
        </div>
        <div class="dateBox">
            <div class="dateMenu">
                <div class="menuItem" :class="{'active':item == timeIndex}" v-for="item in dateData" :key="item" @click="handleTimeSectionChange(item)">
                   {{item}}
                </div>
                <!-- <div class="menuItem" :class="{'active':index == activeIndex}" v-for="(item,index) in dateTime" :key="index" @click="handleChangeTime(index)">{{ item.label }}</div> -->
            </div>
            <div class="timeBox">
                <div v-if="isClosedToday" class="closedText">Closed</div>
                <template v-else>
                    <div v-for="(item,index) in currentTimeSlots" :key="item.times">
                        <div class="timeTag" :class="{ 'timeActive':index == dateTimeIndex }" @click="dateTimeIndex = index">
                            {{ item.time }}
                        </div>
                    </div>
                    <div v-if="currentTimeSlots.length === 0" class="closedText">No available time</div>
                </template>
            </div>
        </div>
        <div class="saveBtn">
            <div @click="handleSave">Save</div>
        </div>
    </div>
</template>
<script>
    export default {
        name:'',
        props:{
            businessHours:{
                type:Object,
                default:()=>({})
            }
        },
        data(){
            return {
                activeDayIndex:0,
                dateData:['Morning','Afternoon','Evening'],
                timeIndex:'Morning',
                dateTimeIndex:0,
                timeData:[],
            }
        },
        computed:{
            getNowDate(){
                return ( type,index=null )=>{
                    if(!this.timeData || this.timeData.length === 0){
                        return ''
                    }
                    let activeIndex = index != null ? index : this.activeDayIndex
                    activeIndex = Math.max(0, Math.min(activeIndex, this.timeData.length - 1))
                    let date = this.timeData[activeIndex].date
                    let dateArr = date.split("-")
                    if( type == 'year' ){
                        return dateArr[0]
                    }else if( type == 'month' ){
                        return dateArr[1]
                    }else if( type == 'day' ){
                        return dateArr[2]
                    }
                    return ''
                }
            },
            activeDayDate(){
                return this.timeData[this.activeDayIndex] || null
            },
            activeBusinessRange(){
                if(!this.activeDayDate) return { start: '00:00:00', end: '00:00:00' }
                const map = ['sunday', 'mondy', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
                const key = map[this.activeDayDate.dayOfWeek]
                const start = this.businessHours && this.businessHours[`${key}_start`] || '00:00:00'
                const end = this.businessHours && this.businessHours[`${key}_end`] || '00:00:00'
                return { start, end }
            },
            isClosedToday(){
                const { start, end } = this.activeBusinessRange
                return this.toMinute(start) === 0 && this.toMinute(end) === 0
            },
            slotsBySection(){
                const sections = {
                    Morning: [],
                    Afternoon: [],
                    Evening: []
                }
                if(this.isClosedToday) return sections
                const { start, end } = this.activeBusinessRange
                const startMinute = this.toMinute(start)
                const endMinute = this.toMinute(end)
                if(endMinute <= startMinute) return sections
                let cur = this.alignToHalfHour(startMinute)
                while(cur < endMinute){
                    const item = {
                        time: this.toAmPm(cur),
                        times: `${this.pad(Math.floor(cur / 60))}:${this.pad(cur % 60)}:00`
                    }
                    if(cur < 12 * 60){
                        sections.Morning.push(item)
                    }else if(cur < 18 * 60){
                        sections.Afternoon.push(item)
                    }else{
                        sections.Evening.push(item)
                    }
                    cur += 30
                }
                return sections
            },
            currentTimeSlots(){
                return this.slotsBySection[this.timeIndex] || []
            }
        },
        created(){
            this.timeData = this.getSevenDays()
            this.resetSectionAndTime()
        },
        watch:{
            businessHours:{
                handler(){
                    this.resetSectionAndTime()
                },
                deep:true
            },
            activeDayIndex(){
                this.resetSectionAndTime()
            }
        },
        methods:{
            formatWeek(dayOfWeek){
                const weekList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                return weekList[Number(dayOfWeek)] || '--'
            },
            toMinute(timeValue){
                if(!timeValue) return 0
                const parts = String(timeValue).split(':')
                const hour = Number(parts[0])
                const minute = Number(parts[1])
                if(!Number.isFinite(hour) || !Number.isFinite(minute)) return 0
                return hour * 60 + minute
            },
            alignToHalfHour(minute){
                const r = minute % 30
                return r === 0 ? minute : minute + (30 - r)
            },
            pad(n){
                return n < 10 ? `0${n}` : `${n}`
            },
            toAmPm(totalMinute){
                const hour24 = Math.floor(totalMinute / 60)
                const minute = totalMinute % 60
                const suffix = hour24 < 12 ? 'AM' : 'PM'
                const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12
                return `${hour12}:${this.pad(minute)}${suffix}`
            },
            resetSectionAndTime(){
                const hasMorning = this.slotsBySection.Morning.length > 0
                const hasAfternoon = this.slotsBySection.Afternoon.length > 0
                const hasEvening = this.slotsBySection.Evening.length > 0
                if(this.isClosedToday){
                    this.dateData = ['Morning','Afternoon','Evening']
                    this.timeIndex = 'Morning'
                    this.dateTimeIndex = 0
                    return
                }
                const sections = []
                if(hasMorning) sections.push('Morning')
                if(hasAfternoon) sections.push('Afternoon')
                if(hasEvening) sections.push('Evening')
                this.dateData = sections.length > 0 ? sections : ['Morning','Afternoon','Evening']
                if(!this.dateData.includes(this.timeIndex)){
                    this.timeIndex = this.dateData[0]
                }
                this.dateTimeIndex = 0
            },
            // Build selectable dates for the next 8 days
            getSevenDays() {
                const days = [];
                const today = new Date();
                for (let i = 0; i < 8; i++) {
                    const currentDate = new Date(today);
                    currentDate.setDate(today.getDate() + i);
                    const year = currentDate.getFullYear();
                    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                    const day = String(currentDate.getDate()).padStart(2, '0');
                    days.push({
                    date: `${year}-${month}-${day}`,
                    dayOfWeek: currentDate.getDay(),
                    isToday: i === 0
                    });
                }
                return days;
            },
            handleDayChange(index){
                this.activeDayIndex = index
            },
            handleTimeSectionChange(section){
                this.timeIndex = section
                this.dateTimeIndex = 0
            },
            handleSave(){
                if(this.isClosedToday){
                    this.$toast && this.$toast('Today is closed')
                    return
                }
                const list = this.currentTimeSlots || []
                const selected = list[this.dateTimeIndex]
                if(!selected){
                    this.$toast && this.$toast('No available time')
                    return
                }
                let date = this.timeData[this.activeDayIndex].date
                let chooseTime = date + ' ' + selected.times
                this.$emit('updateTime',chooseTime)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .dayBox{
        width: 100%;
        padding:1rem  1rem 0 1rem;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        overflow: auto;
        .timeItem{
            flex-shrink: 0;
            width:4rem;
            height: 4.75rem;
            border: 1px solid #EEEEEE;
            border-radius: .3125rem;
            margin-right: .625rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            padding: .3125rem 0;
            box-sizing: border-box;
            .timeLine{
                width: 1.25rem;
                height: .125rem;
                background: #71CE00;
                border-radius: .625rem;
            }
        }
    }
    .dayActive{
        background: #1E3C3E;
        color: #fff;
    }
    .saveBtn{
        width: 100%;
        padding: 1rem;
        box-sizing: border-box;
        div{
            display: flex;
            justify-content: center;
            width: 100%;
            height: 2.5rem;
            align-items: center;
            color: #fff;
            background: #1E3C3E;
            border-radius: .5rem;
        }
    }
    .yearBox{
        display: flex;
        align-items: center;
        font-size: 1rem;
        font-weight: bold;
        justify-content: center;
        margin-top: 2rem;
        .month{
            margin-right: 1rem;
        }
    }
    .dateBox{
        width: 100%;
        padding: 1rem;
        box-sizing: border-box;
        .timeBox{
            width: 100%;
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: .5rem;
            align-items: center;
            font-size: .8125rem;
            color: #626262;
            margin-top: 1rem;
            .timeTag{
                width: 100%;
                height: 2.15rem;
                border-radius: .1875rem;
                background: #fff;
                border: 1px solid #CCCCCC;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .timeActive{
                background: #1E3C3E;
                color: #fff;
                border-color:#1E3C3E;
            }
            .closedText{
                grid-column: 1 / -1;
                width: 100%;
                color: #999999;
                text-align: center;
                padding: 1rem 0;
            }
        }
        .dateMenu{
            width: 100%;
            height: 2.5rem;
            background: #F4F4F4;
            border-radius: .25rem;
            padding: 0.3rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            color: #626262;
            font-size: .875rem;
            .menuItem{
                flex: 1;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: .1875rem;
            }
            .active{
                background: #FFFFFF;
            }
        }
    }
</style>
